import { ADDMEMBER_FAIL, ADDMEMBER_SUCCESS } from '../actionTypes';

const initialState = {
    user: null
};

const addMemberReducer = (state = initialState, action) => {
    switch (action.type) {
        case ADDMEMBER_SUCCESS:
            return {
                ...state,
                isLoggedIn: true,
                user: action.payload.user,
            };
        case ADDMEMBER_FAIL:
            return {
                ...state,
                isLoggedIn: false,
                user: null,
            };
        default:
            break;
    }

    return state;
};

export default addMemberReducer;
